import PortableText from 'components/portableText';
import Image from 'next/image';
import { useNextSanityImage } from 'next-sanity-image';
import { BlogPostDetailType } from 'utilities/propTypes';
import sanityClient from '../../lib/sanity';
import Cell from '../grid/cell';
import Anchor from '../typography/anchor';

const POST_TILE_IMAGE_WIDTH = 864;
const DESIRED_ASPECT_RATIO = 1.5; // 564
const POST_TILE_IMAGE_HEIGHT = POST_TILE_IMAGE_WIDTH / DESIRED_ASPECT_RATIO;

const BlogPostTile = (props) => {
  const { post } = props;

  const imageProps = useNextSanityImage(sanityClient, post.mainImage, {
    imageBuilder: (imageUrlBuilder, options) => {
      const output = imageUrlBuilder
        .width(
          options.width ||
            Math.min(
              options.originalImageDimensions.width,
              POST_TILE_IMAGE_WIDTH
            )
        )
        .height(options.width / 1.5)
        .fit('crop')
        .dpr(2)
        .quality(options.quality || 65)
        // This will behave like `crop('center')` if no hotspot is provided
        .crop('focalpoint')
        .focalPoint(
          post.mainImage?.hotspot?.x || 0,
          post.mainImage?.hotspot?.y || 0
        );
      return output;
    },
  });

  return (
    <Cell
      className="mb-8 line-clamp-3 flex-none shrink basis-[30%] text-left text-sm leading-5 font-light md:basis-full lg:basis-[48%]"
      size={2}
    >
      <Anchor href={post.route}>
        <Image
          {...imageProps}
          width={POST_TILE_IMAGE_WIDTH}
          height={POST_TILE_IMAGE_HEIGHT}
          alt={post.mainImage.alt}
          style={{ width: '100%', height: 'auto' }}
          className="m-0 block w-full shadow-[0_4px_5px_-2px_rgba(0,0,0,0.2)]"
          sizes="
            (max-width: 568px) 100vw,
            (min-width: 568px) and (max-width: 1024px) 50vw,
            (min-width: 1024px) 30vw,
            400px"
          placeholder={post.mainImage.asset.metadata.lqip}
        />
        <h3 className="mt-2 mb-1">{post.title}</h3>
        <PortableText
          blocks={post.description}
          renderLinks={false}
        ></PortableText>
      </Anchor>
    </Cell>
  );
};

export default BlogPostTile;

BlogPostTile.propTypes = BlogPostDetailType;
